// Module
var code = "<mm-card caption=\"'Entities.UserInformation.UserInformation'\" sub-caption=\"$ctrl.subCaption\" icon=\"'user'\" edit=\"$ctrl.editUserInformation()\" is-loading=\"$ctrl.profile === null\"></mm-card> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Auth/Components/Profile/UserInformation/ProfileUserInformation.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;